import React, { useState, useRef, useEffect } from 'react';
import { CloseOutlined, CheckOutlined, ExclamationCircleFilled, MoonFilled, SunFilled } from '@ant-design/icons';
import { Button, Col, Tag, Drawer, Form, Input, Row, Switch, Space, message, Modal, Typography, DatePicker } from 'antd';
import {insert, update, dropParameter, getParameters, getById} from '../../../../apis/FuncionApi';
import dayjs from 'dayjs';
import Editor from '@monaco-editor/react';
import { defFunction, declareFuncionInicio, declareFuncionFin, codeInit} from '@app/constants/definition_python';

const { Title } = Typography;
const { TextArea } = Input;
const { confirm } = Modal;
const App = ({title, id, open, finish}) => {
    const [ form ] = Form.useForm()
    const [ID, setID] = useState(id);
    const [modified, setModified] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [dataParameters, setDataParameters] = useState([]);
    const [openNewParameters, setOpenNewParameters] = useState(false);
    const [selectedDetail, setSelectedDetail] = useState(null);
    const [initialValues, setInitialValues] = useState(null);
    const searchInput = useRef(null);
    const [themeEditor, setThemeEditor] = useState('light');
    
    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            if(!values) return;
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
            return;
        }

        const fields = form.getFieldsValue()
        if(ID > 0){
            //Update
            const payload = {
                id: ID,
                ...fields
            }
            const response = await update(payload);
            if(response.ok){
                message.success('Se actualizó correctamente el concepto!');
            }
        }else{
            //Create
            const payload = {
                id: ID,
                ...fields
            }
            const response = await insert(payload);
            if(response.ok){
                setID(response.payload);
                message.success('Se guardo correctamente el periodo!');
            }
        }

        setModified(true);
    }

    const effectRan = useRef(false);
    useEffect(() => {
        if (!effectRan.current) {
            (async () => {
                if(ID > 0){
                    await refreshData();
                }else{
                    setInitialValues({
                        nombre: null,
                        descripcion: null,
                        funcion: codeInit,
                        ayuda: null,
                        tipo_dato: null,
                        activo: true
                    });
                }
                setModified(false)
            })();
        }
        return () => effectRan.current = true;
    }, []);

    const refreshData = async ()=> {
        const response = await getById(ID);
        if(response.ok){
            let item = response.payload;
            if(item.fecha){
                item.fecha = dayjs(item.fecha, 'YYYY-MM-DD');
            }
            setInitialValues(item);
        }
    }

    const onClickNewDetail = ()=>{
        setOpenNewParameters(true);
        setSelectedDetail(null);
    }

    const onClose = (reload)=>{
        finish(reload ?? modified);
        setInitialValues(null);
        setShowModal(false);
    }

    const finishDetail = async () => {
       setOpenNewParameters(false);
       await refreshParameters();
    }

    const refreshParameters = async ()=> {
        const response = await getParameters(ID);
        if(response.ok){
            let list = response.payload;
            setDataParameters(list);
        }
    }

    React.useEffect(() => {
        setShowModal(open);
    }, [open]);

    const deleteConfirm = async (item) => {
        confirm({
            title: '¿Confirmas en eliminar el parametro?',
            icon: <ExclamationCircleFilled />,
            content: 'No podrás recuperar su información',
            onOk: ()=>{deleteOk(item.id)},
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const deleteOk = async (id)=>{
        const response = await dropParameter(id);
        if(response.ok){
            message.success('¡El periodo ha sido eliminadó!');
            await refreshParameters();
        }
    }

    const editorRef = useRef(null);
    function handleEditorDidMount(editor, monaco) {
        editorRef.current = editor;
    }

    const onChangeTheme = async (value) => {
        setThemeEditor(value?'light':'vs-dark');
    }

    return (
        <Drawer
            title={title}
            width={720}
            placement={"right"}
            onClose={onClose}
            open={open}
            closable={true}
            extra={<Space>
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={handleOk} type="primary">
                Guardar
                </Button>
            </Space>}
        >
            <>
                <div>
                    <div style={{float: 'left'}}>
                        <span title=""></span>
                    </div>
                    <span class="" style={{float:'right'}}>
                       
                    </span>
                </div>
                {/* <PageHeader ghost={false} title="Remisiones" extra={[ 
                <Space>
                    <Button onClick={onClose}>Cancelar</Button>
                    <Button onClick={handleOk} type="primary">
                    Guardar
                    </Button>
                </Space>]} />*/}
            {
                initialValues && 
                <Form 
                    layout="vertical" 
                    form={form} 
                    requiredMark 
                    autoComplete="off"
                    initialValues={initialValues} 
                    onFinish={handleOk}>
                    <Row gutter={16}>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                            <Row gutter={16}>
                                <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                    <Form.Item
                                        name="nombre"
                                        label="Nombre"
                                        rules={[
                                        {
                                            required: true,
                                            message: 'Por favor agrega un nombre',
                                        },
                                        ]}
                                    >
                                        <Input placeholder="Por favor agrega un nombre" />
                                    </Form.Item>
                                </Col>
                                <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                    <Form.Item
                                        name="descripcion"
                                        label="Descripción"
                                        rules={[
                                        {
                                            required: true,
                                            message: 'Por favor agrega una descripción',
                                        },
                                        ]}
                                    >
                                        <Input placeholder="Por favor agrega una descripción" />
                                    </Form.Item>
                                </Col>
                                <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                    <Form.Item
                                        name="ayuda"
                                        label="Ayuda"
                                        rules={[
                                        {
                                            required: false,
                                            message: 'Por favor agrega una ayuda',
                                        },
                                        ]}
                                    >
                                        <TextArea placeholder="Por favor agrega una descripción" rows={4} maxLength={6}/>
                                    </Form.Item>
                                </Col>
                                <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                    <Form.Item
                                        name="fecha"
                                        label="Fecha"
                                    >
                                        <DatePicker placeholder="DD/MM/YYYY"  style={{width: '100%',}} format={'DD/MM/YYYY'}/>
                                    </Form.Item>
                                </Col>
                                <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                    <Form.Item
                                        name="activo"
                                        label="Activo"
                                        >
                                        <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                            <Row gutter={16}>
                                <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}} style={{marginBottom: 20, marginLeft: 20}}>
                                    Color del editor
                                    <Switch defaultChecked checkedChildren={<SunFilled />} unCheckedChildren={<MoonFilled />} onChange={onChangeTheme} style={{marginLeft: 20}}/>
                                </Col>
                            </Row>
                            <Editor
                                height="90vh"
                                defaultLanguage="python"
                                defaultValue={initialValues.funcion}
                                theme={themeEditor}
                                options={{
                                    inlineSuggest: true,
                                    fontSize: "16px",
                                    formatOnType: true,
                                    autoClosingBrackets: true,
                                    minimap: { scale: 10 }
                                }}
                                onMount={handleEditorDidMount}
                                />
                        </Col>
                    </Row>
                </Form>
            }
            </>
        </Drawer>
    );
};
export default App;